import React from 'react';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';

/* This component must be rendered even when props.betslipCollapsed is false, otherwise the widget doesn't work
   when the betslip is opened again */
export default function FeedWidgetContainer(props) {
    const widgetContext = React.useContext(WidgetContext);

    if (widgetContext.widgetMatchId == null || widgetContext.widgetContainerId !== '#collassaWidget') {
        return null;
    }

	const isBrWidgetS5 = brWidgetS5Enabled(widgetContext.widgetSportId, widgetContext.widgetProviderType);
    const isBetgeniusWidget = bgWidgetEnabled(widgetContext.widgetSportId, widgetContext.widgetProviderType,widgetContext.widgetGeniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType,widgetContext.widgetLsportId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(widgetContext.widgetProviderType);

    let classes = '';
    classes += isBetgeniusWidget ? ' betgeniusWidget' : '';
    classes += props.betslipCollapsed ? ' d-none' : '';

    return (
        <div className={"widget-filtro-side margine-giu live-tracker-widget" + classes}>
            <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx pointer" data-toggle="collapse" href="#collassaWidget">
                <span data-toggle="collapse" href="#collassaWidget">
                    <i className="fas fa-caret-down"></i>
                </span>
            </div>
            {(() => {
                if (flashbetWidgetUrl) {
                    return <FlashbetWidget url={flashbetWidgetUrl}/>;
                } else if (isBetgeniusWidget) {
                    return <BetGeniusWidget url={getBetgeniustWidgetUrl(widgetContext.widgetSportId)} />;
                } else if (isStatsCoreWidget) {
                    return <StatsCoreWidget />
                } else {
                    return (
                        <div className={`bordato-widget collapse show ${isBrWidgetS5 ? 'brWidgetS5' : ''} `} id="collassaWidget"></div>
                    );
                }
            })()}
        </div>
    );
}
